import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';

import { updateJobDescriptionFromExternalWebsite } from './restApi';

const UpdateJobDescriptionFromExternalWebsiteForm = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { onResponse, onError, updateJobDescriptionFromExternalWebsiteFormTitle, closeUpdateJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateJobDescriptionFromExternalWebsite({
      onResponse,
      onError,
      body: {
        authenticityToken,
        updateJobDescriptionFromExternalWebsite: jobDescriptionsFromExternalWebsitesState?.updateJobDescriptionFromExternalWebsite,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Job Title" id="job_title">
        <Input
          type="text"
          value={jobDescriptionsFromExternalWebsitesState?.updateJobDescriptionFromExternalWebsite?.title || ''}
          onChange={(e) => {
            updateJobDescriptionFromExternalWebsiteFormTitle(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeUpdateJobDescriptionFromExternalWebsiteModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Update
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UpdateJobDescriptionFromExternalWebsiteForm;